import { withI18n } from 'react-i18next';
import EmailInvoicesModal from './EmailInvoicesModal';

export const pureComponent = EmailInvoicesModal;
export default withI18n()(EmailInvoicesModal);
